import { routes } from '../../utils/helpers/ApiClient';
import { Route } from 'react-router-dom';
import CMSWrapper from '../CMSWrapper';
import {
  AccountChooser,
  BlocksEdit,
  BlocksOrderPage,
  BlocksPage,
  CalendarEdit,
  CalendarInput,
  CalendarPage,
  ArticlePage,
  ArticlesEdit,
  Dashboard,
  DepartmentsEdit,
  DepartmentsPage as DepartmentsCMSPage,
  UsefulLinksPage,
  UsefulLinksEdit,
  MenuEdit,
  MenuOrderPage,
  MenuPage,
  NewsCategoryEdit,
  NewsCategoryPage,
  NewsEdit,
  NewsPages,
  SearchAdminPage,
  SearchHistoryPage,
  SliderOrderPage,
  SlidersEditPage,
  SlidersPage,
} from '../pages/CMSPages/index';
import React from 'react';

const CoreCMSRoutes = () => (
  <>
    <Route
      index
      element={
        <CMSWrapper>
          <Dashboard />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsAccountChoose}
      element={
        <CMSWrapper permissions={['login-as-user']}>
          <AccountChooser />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsDepartments}
      element={
        <CMSWrapper permissions={['departments.index']}>
          <DepartmentsCMSPage />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsDepartmentEdit}/:id`}
      element={
        <CMSWrapper mode={'edit'} permissions={['departments.show']}>
          <DepartmentsEdit />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsNews}
      element={
        <CMSWrapper permissions={['news.index']}>
          <NewsPages />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsNewsEdit}/:id`}
      element={
        <CMSWrapper permissions={['news.show']}>
          <NewsEdit mode={'edit'} />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsNewsCreate}
      element={
        <CMSWrapper permissions={['news.store']}>
          <NewsEdit mode={'create'} />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsNewsCategories}
      element={
        <CMSWrapper permissions={['news-categories.index']}>
          <NewsCategoryPage />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsNewsCategoriesEdit}/:id`}
      element={
        <CMSWrapper permissions={['news-categories.show']}>
          <NewsCategoryEdit mode={'edit'} />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsNewsCategoriesCreate}
      element={
        <CMSWrapper permissions={['news-categories.store']}>
          <NewsCategoryEdit mode={'create'} />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsSliders}
      element={
        <CMSWrapper permissions={['sliders.index']}>
          <SlidersPage />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsSliderCreate}
      element={
        <CMSWrapper permissions={['sliders.store']}>
          <SlidersEditPage mode={'create'} />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsSliderEdit}/:id`}
      element={
        <CMSWrapper permissions={['sliders.show']}>
          <SlidersEditPage mode={'edit'} />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsSliderOrder}
      element={
        <CMSWrapper permissions={['sliders.show']}>
          <SliderOrderPage />{' '}
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsBlocks}
      element={
        <CMSWrapper permissions={['blocks.index']}>
          <BlocksPage />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsBlocksCreate}
      element={
        <CMSWrapper permissions={['blocks.store']}>
          <BlocksEdit mode={'create'} />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsBlocksEdit}/:id`}
      element={
        <CMSWrapper permissions={['blocks.show']}>
          <BlocksEdit mode={'edit'} />{' '}
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsBlocksOrder}
      element={
        <CMSWrapper permissions={['blocks.show']}>
          <BlocksOrderPage />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsUsefulLinks}
      element={
        <CMSWrapper permissions={['useful-links.index']}>
          <UsefulLinksPage />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsUsefulLinksCreate}
      element={
        <CMSWrapper permissions={['useful-links.store']}>
          <UsefulLinksEdit mode={'create'} />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsUsefulLinksEdit}/:id`}
      element={
        <CMSWrapper permissions={['useful-links.show']}>
          <UsefulLinksEdit mode={'edit'} />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsArticles}
      element={
        <CMSWrapper permissions={['articles.index']}>
          <ArticlePage />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsArticleCreate}
      element={
        <CMSWrapper permissions={['articles.store']}>
          <ArticlesEdit mode={'create'} />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsArticleEdit}/:id`}
      element={
        <CMSWrapper permissions={['articles.show', 'articles.update']}>
          <ArticlesEdit mode={'edit'} />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsMenu}
      element={
        <CMSWrapper permissions={['menu.index']}>
          <MenuPage />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsMenuCreate}
      element={
        <CMSWrapper permissions={['menu.store']}>
          <MenuEdit mode={'create'} />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsMenuEdit}/:id`}
      element={
        <CMSWrapper permissions={['menu.show']}>
          <MenuEdit mode={'edit'} />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsMenuOrder}
      element={
        <CMSWrapper permissions={['menu.show']}>
          <MenuOrderPage />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsCalendar}`}
      element={
        <CMSWrapper permissions={['calendar.index']}>
          <CalendarPage />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsCalendarCreate}`}
      element={
        <CMSWrapper permissions={['calendar.store']}>
          <CalendarEdit mode={'create'} />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsCalendarEdit}/:id`}
      element={
        <CMSWrapper permissions={['calendar.show']}>
          <CalendarEdit mode={'edit'} />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.calendarImport}`}
      element={
        <CMSWrapper permissions={['calendar-import']}>
          <CalendarInput />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsSearchHistory}
      element={
        <CMSWrapper permissions={['search-history.index']}>
          <SearchHistoryPage />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsSearchAdmin}
      element={
        <CMSWrapper permissions={['search-admin.index']}>
          <SearchAdminPage />
        </CMSWrapper>
      }
    />
  </>
);
export default CoreCMSRoutes;
